<template>
	<div>
		<vue-progress-bar></vue-progress-bar>
		<!-- <transition name="fade">
			<div class="cookie-info" v-if="showCookiesInfo">
				<div class="cookie-info-left">Esta página web utiliza cookies para mejorar su experiencia. Si continua navegando, acepta nuestra <a href="#">Política de Privacidad</a>.</div>
				<div class="cookie-info-close" v-on:click="aceptarCookies">Cerrar</div>
			</div>
		</transition> -->
		<app-header-top v-if="$route.meta.hideHeaderFooter !== true"></app-header-top>
		<app-header v-if="$route.meta.hideHeaderFooter !== true"></app-header>
		<main>
			<transition name="fade" mode="out-in">
				<router-view></router-view>
			</transition>
		</main>
		<app-footer v-if="$route.meta.hideHeaderFooter !== true"></app-footer>
		<transition name="fade">
			<div class="app-loader" v-if="$store.state.cargando">
				<img src="./assets/cndef-loader.gif" alt="Cargando...">
			</div>
		</transition>
	</div>
</template>

<script>
	import axios from 'axios'
	import Header from './components/Shared/Header.vue';
	import HeaderTop from './components/Shared/HeaderTop.vue';
	import Footer from './components/Shared/Footer.vue';

	export default {
		data() {
			return {
				showCookiesInfo: null,
				scrollPosition: 0,
				loading: true,
				timer: null
			}
		},
		components: {
			'app-header-top': HeaderTop,
			'app-header': Header,
			'app-footer': Footer
		},
		methods: {
			updateScroll() {
				this.scrollPosition = window.scrollY
				// if(this.showCookiesInfo){
				// 	if(this.scrollPosition >= 250)
				// 		this.showCookiesInfo = false
				// }
			},
			// aceptarCookies(){
			// 	this.showCookiesInfo = false;

			// 	// Creo cookie que expira en 1 año
			// 	this.$cookies.set('AceptaCookies','1');
			// },
			async validarQueue(){
				try {
					let response = await axios.post('/WSFilaActiva', {});

					if(response.data.isFilaActiva === true && response.data.URLFila){
						window.location = response.data.URLFila
					}
				} catch (error) {
					console.log('Ocurrió un error al validar queue');
				}
			}
		},
		mounted () {
			document.onreadystatechange = () => {
				if(document.readyState == 'complete'){
					this.$store.state.cargando = false;
				} else {
					this.$store.state.cargando = true;
				}
			}

			this.$Progress.finish()
			window.addEventListener('scroll', this.updateScroll);

			// if(this.$cookies.isKey('AceptaCookies'))
			// 	this.showCookiesInfo = false
			// else
			// 	this.showCookiesInfo = true
		},
		created () {
			this.timer = setInterval(() => {
				this.validarQueue()
			}, 300000)

			this.$Progress.start()
			this.$router.beforeEach((to, from, next) => {
				if (to.meta.progress !== undefined) {
					let meta = to.meta.progress
					this.$Progress.parseMeta(meta)
				}
				this.$Progress.start()
				next()
			})
			this.$router.afterEach((to, from) => {
				setTimeout(() => this.loading = false, 1500)
				this.$Progress.finish()
			})
		},
		beforeDestroy() {
			clearInterval(this.timer)
		}
	}
</script>

<style lang="scss">
	@import 'styles/typography.scss';
	@import 'styles/mixins.scss';

	:root{
		--color-white:#FFFFFF;
		--color-black:#000000;
		--color-dark:#161616;
		--color-red:#C00C30;
		--color-grey:#999999;
		--color-grey-medium:#DCDCDC;
		--color-grey-light:#E8E8E8;
		--color-grey-lighter:#F2F2F2;
		--color-blue:#0046AD;
		--color-blue-light:#ADDAF6;
		--color-blue-dark:#002F87;
		--color-blue-darker:#001E57;
		--font-family-kapra-bold:'Kapra Bold',sans-serif;
		--font-family-kapra-condensed:'Kapra Condensed',sans-serif;
		--font-family-poppins:'Poppins',sans-serif;
		--font-family-fira:'Fira Sans',sans-serif;
		--font-family-staat:'Staatliches',sans-serif;
		--font-weight-regular:400;
		--font-weight-semibold:600;
		--font-weight-bold:700;
		--grid-padding-size:16px;
		--grid-margin-row-size:-16px;
		--grid-container-maxwidth:1400px;
		--bs-gutter-x:16px;

		--height-page: calc(100vh - 120px);

		--height-top-header: 46px;
		--height-nav-menu: 72px;
		--height-footer: 75px;
	}

	*, *::after, *::before {
		box-sizing: border-box;
	}

	html, body{
		font-family: 'Fira Sans', sans-serif;
		margin: 0;
		padding: 0;
		// color: #484848;
		color: #29355c;
	}

	body{
		-moz-osx-font-smoothing: grayscale;
		-webkit-font-smoothing: antialiased;
	}

	a{
		text-decoration: none;
		text-transform: none;
		color: #007bff;
		transition: all .2s;
	}

	a:hover{
		text-decoration: underline;
	}

	input{
		border: 0;
		outline: none;
		outline-color: transparent;
		box-shadow: none;
		padding: 0;
		margin: 0;
		background-color: transparent;
	}

	.container{
		max-width: 1260px;
		margin: 0 auto;
		// padding: 30px 0;
		padding: 0;
	}

	main{
		width: 100%;
		margin: 0;
		padding: 0;
		// padding-top: 76px;
	}

	.cookie-info{
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		color: var(--color-white);
		@include flex(row, space-between, center);
		font-family: var(--font-family-fira);
		font-size: 13px;
		-webkit-letter-spacing: 0;
		-moz-letter-spacing: 0;
		-ms-letter-spacing: 0;
		letter-spacing: 0;
		z-index: 100;
		background-color: var(--color-blue-dark);

		.cookie-info-left{
			max-width: 90%;
			font-size: 14px;
			line-height: 20px;
			padding: 18px 0 18px 40px;
			font-family: var(--font-family-fira);
			margin: 0;
			-webkit-letter-spacing: 0;
			-moz-letter-spacing: 0;
			-ms-letter-spacing: 0;
			letter-spacing: 0;

			a{
				text-decoration: underline;
				color: var(--color-white);
			}
		}

		.cookie-info-close{
			height: 100%;
			text-transform: uppercase;
			font-family: var(--font-family-poppins);
			font-weight: var(--font-weight-bold);
			font-size: 16px;
			position: relative;
			cursor: pointer;
			background-color: var(--color-red);
			color: var(--color-white);
			-webkit-transition: background-color .2s ease;
			transition: background-color .2s ease;
			-webkit-letter-spacing: 0;
			-moz-letter-spacing: 0;
			-ms-letter-spacing: 0;
			letter-spacing: 0;
			min-height: 56px;
			padding: 0 48px;
			line-height: 25px;
			@include flex(row, center, center);
		}
	}

	.horizontal-menu{
		width: 100%;
		background-color: var(--color-white);
		z-index: 99;
		border-bottom: 1px solid var(--color-grey-light);
		position: -webkit-sticky;
		position: sticky;
		top: 64px;
		overflow-y: hidden;
		@include flex(row, center, center);

		.menu-item{
			padding: 0 20px;
			background-color: transparent;
			cursor: pointer;
			-webkit-text-decoration: none;
			text-decoration: none;
			@include flex(row, center, center);

			span{
				padding-top: 25px;
				padding-bottom: calc(25px - 4px);
				font-size: 16px;
				height: 100%;
				border-bottom: 4px solid;
				border-bottom-color: transparent;
				-webkit-transition: border-bottom-color 0.2s ease-in;
				transition: border-bottom-color 0.2s ease-in;
				white-space: nowrap;
				font-family: var(--font-family-poppins);
				color: var(--color-dark);
				-webkit-text-decoration: none !important;
				text-decoration: none !important;
				text-transform: uppercase;
				font-weight: var(--font-weight-bold);
			}

			&.router-link-exact-active{
				span{
					border-bottom-color: var(--color-red);
				}
			}

			&:hover{
				span{
					border-bottom-color: var(--color-red);
				}
			}
		}
	}

	@media screen and(max-width: 1140px){
		.horizontal-menu{
			top: 56px;
		}
	}

	@media screen and(max-width: 680px){
		.horizontal-menu{
			@include flex(row, flex-start, center);
		}
	}

	.fade-enter-active, .fade-leave-active {
		transition: opacity .2s
	}
	.fade-enter, .fade-leave-to {
		opacity: 0
	}

	.app-loader{
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		margin: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 999;	
		background-color: rgba(255, 255, 255, 0.98);
		transition: all .2s;

		img{
			width: 120px;
			height: auto;
		}
	}

	.tippy-backdrop{
		background-color: var(--color-blue-darker);
	}

	/* Modals */
	// .vm--container{
	// 	backdrop-filter: blur(3px);
	// }

	.imagenSector .vm--modal{
		display: flex !important;
		justify-content: center !important;
		align-items: center !important;
		top: 50% !important;
		left: 50% !important;
		width: fit-content !important;
		height: fit-content !important;
		transform: translate(-50%, -50%) !important;
		overflow: inherit !important;
	}

	.imagenSector .imagen-sector{
		width: auto;
		height: auto;
		max-width: calc(100vw - 48px);
		max-height: calc(100vh - 48px);
	}

	.imagenSector .vm--overlay{
		background: rgba(0, 0, 0, 0.9);
	}

	.imagenSector .cerrar-imagenSector{
		content: '';
		width: 24px;
		height: 24px;
		background: rgba(0, 0, 0, 0.3);
		border-radius: 0;
		margin: 0;
		padding: 0;
		position: absolute;
		top: 15px;
		right: 15px;
		z-index: 999;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		transition: all .2s;

		svg{
			width: 22px;
			height: auto;
			line-height: 1em;
			color: #fff;
			margin: 0;
		}

		&:hover{
			background-color: #c61431;

			svg{
				color: #fff;
			}
		}
	}

	.prompt-pago .vm--overlay{
		background: rgba(0, 0, 0, 0.9);
	}

	.prompt-pago .vm--modal{
		width: 100% !important;
		max-width: 490px !important;
		height: auto !important;
		top: 50% !important;
		left: 50% !important;
		transform: translate(-50%, -50%);
		overflow: hidden;
		background: transparent;
		box-shadow: none
	}

	.promptEliminarAmigo, .promptCancelarReserva, .promptCancelarTicket {
		.vm--overlay{
			background: rgba(0, 0, 0, 0.9);
		}

		.vm--modal{
			@include flex(column, center, center);
			width: calc(100vw - 48px) !important;
			max-height: calc(100vh - 48px);
			height: auto !important;
			top: 50% !important;
			left: 50% !important;
			transform: translate(-50%, -50%) !important;
			padding: 48px 48px 56px;
			background-color: var(--color-white);
			border-radius: 0px;

			h2{
				color: var(--color-red);
				margin: 0;
				margin-bottom: 24px;
				font-weight: initial;
				font-size: 48px;
				line-height: 46px;
				font-family: var(--font-family-kapra-bold);
				text-transform: uppercase;
			}

			p{
				font-size: 20px;
				line-height: 24px;
				margin: 0;
				font-family: var(--font-family-poppins);
				font-weight: bold;
				text-transform: uppercase;
				color: var(--color-dark);
				text-align: center;
			}

			div{
				width: 100%;
				margin-top: 40px;
				@include flex(row, space-between, center);


				button{
					width: calc(50% - 12px);
					text-transform: uppercase;
					font-family: var(--font-family-poppins);
					font-weight: var(--font-weight-bold);
					position: relative;
					cursor: pointer;
					background-color: var(--color-red);
					color: var(--color-white);
					-webkit-transition: background-color .2s ease;
					transition: background-color .2s ease;
					-webkit-letter-spacing: 0;
					-moz-letter-spacing: 0;
					-ms-letter-spacing: 0;
					letter-spacing: 0;
					min-height: 48px;
					padding: 0 24px;
					font-size: 16px;
					-webkit-letter-spacing: 0;
					-moz-letter-spacing: 0;
					-ms-letter-spacing: 0;
					letter-spacing: 0;
					line-height: 25px;
					outline: none;
					border: none;
					transition: all .2s;

					&:hover{
						background-color: var(--color-blue-dark);
					}

					&.aux{
						background-color: var(--color-grey-lighter);
						color: var(--color-dark);

						&:hover{
							background-color: var(--color-dark);
							color: var(--color-white);
						}
					}
				}
			}

			@media screen and (min-width: 992px){
				max-width: 700px;
			}
		}
	}

	.promptElegirAsiento {
		.vm--overlay{
			background: rgba(0, 0, 0, 0.9);
		}

		.vm--modal{
			@include flex(column, center, center);
			width: calc(100vw - 48px) !important;
			max-height: calc(100vh - 48px);
			height: auto !important;
			top: 50% !important;
			left: 50% !important;
			transform: translate(-50%, -50%) !important;
			padding: 0px;
			background-color: var(--color-white);
			border-radius: 0px;
			transition: aspect-ratio .1s;

			// Estilos popup
			.escenario-sector-content{
				width: 100%;
				height: 100%;
				position: relative;
				@include flex(column, space-between, flex-start);

				.escenario-sector-header{
					width: 100%;
					// background-color: var(--color-blue);
					padding: 0px;
					border-radius: 0px;
					height: 56px;
					@include flex(row, space-between, center);

					.escenario-sector-header-cerrar{
						cursor: pointer;
						margin: 0;
						padding: 0px;
						border-radius: 0px;
						background-color: var(--color-red);
						width: 56px;
						height: 56px;
						@include flex(row, center, center);

						svg{
							color: var(--color-white);
							width: 24px;
							height: auto;
						}
					}

					.escenario-header-left{
						padding-top: 16px;
						padding-left: 16px;
						@include flex(row, flex-start, center);

						.escenario-sector-foto{
							@include flex(row, flex-start, center);
							margin: 0;
							margin-left: 16px;
							margin-top: -3px;
							border-radius: 6px;
							padding: 3px 10px 3px 3px;
							border: 1px solid var(--color-grey-medium);
							transition: all .2s;

							svg{
								width: 16px;
								height: 16px;
								margin-right: 6px;
								color: #999;
							}

							img{
								cursor: pointer;

								&:hover{
									box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.1);
								}
							}

							span{
								margin-left: 6px;
								font-size: 11px;
								line-height: 1em;
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
								font-weight: var(--font-weight-bold);
								color: var(--color-dark);
								letter-spacing: 0.3px;
							}
						}

						.escenario-sector-ubicacion{
							@include flex(column, center, flex-start);

							span.escenario-sector-descripcion{
								margin: 0;
								margin-top: -5px;
								color: var(--color-red);
								font-weight: initial;
								font-size: 32px;
								line-height: 36px;
								font-family: var(--font-family-kapra-bold);
								text-transform: uppercase;
							}

							span.escenario-sector-tribuna{
								margin: 0;
								font-size: 14px;
								line-height: 18px;
								font-family: var(--font-family-fira);
								font-weight: bold;
								color: var(--color-dark);
								margin-bottom: 5px;
							}
						}

						.escenario-sector-cantidad{
							margin-left: 20px;
							padding-left: 20px;
							@include flex(row, flex-start, center);
							border-left: 1px solid var(--color-grey-light);

							.cantidad-tickets{
								@include flex(row, flex-start, center);
								// border-bottom: 1px dashed #ccc;

								span.cant-tickets-text{
									font-weight: 400;
									font-size: 13px;
									text-transform: uppercase;
									// padding-bottom: 5px;
									line-height: 1em;
									font-family: var(--font-family-poppins);
									text-align: center;
									font-weight: var(--font-weight-bold);
									color: var(--color-dark);
									-webkit-touch-callout: none;
									-webkit-user-select: none;
									-khtml-user-select: none;
									-moz-user-select: none;
									-ms-user-select: none;
									user-select: none;
									margin-right: 10px;
								}

								.contador-tickets{
									@include flex(row, center, center);
									width: 100px;
									height: 40px;
									-webkit-touch-callout: none;
									-webkit-user-select: none;
									-khtml-user-select: none;
									-moz-user-select: none;
									-ms-user-select: none;
									user-select: none;

									input{
										text-align: center;
										width: 40%;
										align-self: stretch;
										font-family: var(--font-family-poppins);
										font-size: 15px;
										font-weight: 700;
										background-color: var(--color-red);
										border-radius: 0;
										border: none;
										outline: none;
										color: var(--color-white);
										// border: 1px solid #11244d;
										border: none;
										border-left: none;
										border-right: none;

										-webkit-touch-callout: none;
										-webkit-user-select: none;
										-khtml-user-select: none;
										-moz-user-select: none;
										-ms-user-select: none;
										user-select: none;
									}

									span{
										cursor: pointer;
										width: 30%;
										@include flex(row, center, center);
										align-self: stretch;
										background-color: var(--color-red);
										transition: all .2s;

										svg{
											width: 17px;
											height: auto;
											color: var(--color-white);
											stroke-width: 2px;
											margin: 0;
										}

										&:hover{
											opacity: 0.9;
										}
									}
								}
							}
						}
					}
				}

				.escenario-sector-svg{
					background-color: var(--color-white);
					margin: 0;
					padding: 0;
					padding-bottom: 0;
					padding-top: 20px;
					width: 100%;
					margin-bottom: -6px;
					resize: both;
					overflow: auto;
					

					img{
						width: 100%;
					}
				}

				.escenario-sector-leyendas{
					position: absolute;
					bottom: 8px;
					right: 8px;
					margin: 0;
					padding: 6px;
					// background-color: var(--color-white);
					background-color: rgba(255, 255, 255, 1);
					border-radius: 99px;
					@include flex(row, center, center);

					.escenario-sector-leyenda{
						@include flex(row, center, center);
						margin: 0 8px;

						img{
							width: 14px;
							height: auto;
							margin-right: 4px;
						}

						svg{
							margin-right: 4px;
						}

						span{
							font-size: 10px;
							line-height: 1em;
							font-family: var(--font-family-poppins);
							text-transform: uppercase;
							font-weight: var(--font-weight-bold);
							color: var(--color-dark);
							letter-spacing: 0.3px;
						}
					}
				}
			}

			.escenario-sector-loader{
				@include flex(row, center, center);
				width: 100%;
				height: calc(100% - 56px);
				position: absolute;
				bottom: 0px;
				left: 0px;
				z-index: 999;
				
				.loader{
					@include flex(column, center, center);

					span{
						font-family: var(--font-family-poppins);
						text-transform: uppercase;
						font-weight: var(--font-weight-bold);
						margin-top: 12px;
						color: #16497e;
						font-size: 14px;
					}

					img{
						width: 60px;
					}
				}
			}

			@media screen and (min-width: 992px){
				max-height: 96vh;
				max-width: 96vw;
				aspect-ratio: 1033/848;
			}
		}
	}

	// Responsive prompt seleccionar asiento
	@media screen and (max-width: 700px){
		.promptElegirAsiento{
			.vm--modal{
				width: calc(100vw - 16px) !important;
				// height: calc(100vh - 16px) !important;
				// max-height: calc(100vh - 16px) !important;
				max-width: calc(100vw - 16px) !important;
				margin: 0px !important;

				// width: calc(100vw - 18px) !important;
				// max-height: calc(100vh - 18px);

				.escenario-sector-content{
					.escenario-sector-header{
						position: fixed;
						top: 0px;
						align-items: flex-start;
						padding: 0px;
						height: auto;

						.escenario-header-left{
							padding-left: 10px;
							padding-top: 0px;
							.escenario-sector-ubicacion{
								span.escenario-sector-descripcion{
									font-size: 20px;
									line-height: 22px;
								}

								span.escenario-sector-tribuna{
									font-size: 11px;
									line-height: 13px;
									margin-bottom: 0px;
								}
							}

							.escenario-sector-cantidad{
								padding-left: 8px;
								margin-left: 8px;
								.cantidad-tickets{
									span.cant-tickets-text{
										font-size: 10px;
										max-width: 75px;
										text-align: left;
										margin-right: 6px;
									}

									.contador-tickets{
										width: 70px;

										span{
											background-color: var(--color-white);
											svg{
												width: 15px;
												color: var(--color-blue);
												border: 1px solid var(--color-blue);
											}
										}

										input{
											background-color: var(--color-white);
											font-size: 13px;
											color: var(--color-blue);
										}
									}
								}
							}
						}

						.escenario-sector-header-cerrar{
							width: 36px;
							height: 36px;

							svg{
								width: 16px;
							}
						}
					}

					.escenario-sector-leyendas{
						display: none;
						// bottom: 4px;
						// right: 4px;
						// padding: 3px;
						// .escenario-sector-leyenda{
						// 	margin: 0 4px;
						// 	span{
						// 		font-size: 8px;
						// 	}

						// 	svg{
						// 		margin-right: 2px;
						// 		width: 12px;
						// 		height: 12px;
						// 	}

						// 	img{
						// 		width: 12px;
						// 		height: auto;
						// 	}
						// }
					}

					.escenario-sector-svg{
						// height: calc(100vh - 56px);
						height: auto;
						margin-top: 40px;
						padding: 0px;
						@include flex(column, center, center);
					}
				}
			}
		}
	}

	.promptPreseleccionPalco, .promptPreseleccionIntegrante {
		.vm--overlay{
			background: rgba(0, 0, 0, 0.9);
		}

		.vm--modal{
			@include flex(column, center, center);
			width: calc(100vw - 48px) !important;
			max-height: calc(100vh - 48px) !important;
			height: 700px !important;
			max-width: 600px !important;
			top: 50% !important;
			left: 50% !important;
			transform: translate(-50%, -50%) !important;
			padding: 0px;
			background-color: var(--color-white);
			border-radius: 0px;

			// Estilos popup
			.preseleccion-palco-content{
				width: 100%;
				height: 100%;
				position: relative;
				@include flex(column, flex-start, flex-start);

				.preseleccion-palco-header{
					width: 100%;
					// background-color: var(--color-blue);
					padding: 0px;
					border-radius: 0px;
					height: 66px;
					@include flex(row, space-between, flex-start);

					.preseleccion-palco-header-cerrar{
						cursor: pointer;
						margin: 0;
						padding: 0px;
						border-radius: 0px;
						background-color: var(--color-red);
						width: 56px;
						height: 56px;
						@include flex(row, center, center);

						svg{
							color: var(--color-white);
							width: 24px;
							height: auto;
						}
					}

					.preseleccion-header-left{
						padding-top: 6px;
						padding-left: 16px;
						@include flex(row, flex-start, center);

						.preseleccion-palco-ubicacion{
							@include flex(column, center, flex-start);

							span.preseleccion-palco-descripcion{
								margin: 0;
								margin-top: -5px;
								color: var(--color-red);
								font-weight: initial;
								font-size: 32px;
								line-height: 36px;
								font-family: var(--font-family-kapra-bold);
								text-transform: uppercase;
							}

							span.preseleccion-palco-tribuna{
								margin: 0;
								font-size: 14px;
								line-height: 18px;
								font-family: var(--font-family-fira);
								font-weight: bold;
								color: var(--color-dark);
								margin-bottom: 5px;
							}
						}
					}
				}

				.preseleccion-palco-main{
					width: 100%;
					height: calc(100% - 56px);
					padding: 16px;
					overflow-y: scroll;

					&::-webkit-scrollbar-track
					{
						-webkit-box-shadow: inset 0 0 6px var(--color-white);
						box-shadow: inset 0 0 6px var(--color-white);
						background-color: var(--color-white);
					}

					&::-webkit-scrollbar
					{
						width: 6px;
						background-color: var(--color-white);
					}

					&::-webkit-scrollbar-thumb
					{
						background-color: var(--color-grey-medium);
					}

					.preseleccion-info{
						width: 100%;
						margin-bottom: 10px;

						span{
							font-size: 12px;
							font-family: var(--font-family-fira);
							color: var(--color-dark);
							line-height: 1.4em;
							display: inline-block;
						}
					}

					.preseleccion-filtros{
						width: 100%;
						@include flex(column, flex-start, flex-start);
						margin-bottom: 10px;
						padding-bottom: 10px;

						span{
							margin: 0;
							font-size: 14px;
							line-height: 18px;
							font-family: var(--font-family-fira);
							font-weight: var(--font-weight-bold);
							color: var(--color-dark);
							margin-bottom: 5px;
						}

						.preseleccion-filtro-row{
							@include flex(row, space-between, center);
							width: 100%;

							.preseleccion-filtro{
								@include flex(row, flex-start, center);
								width: calc(50% - 10px);

								input{
									font-size: 13px;
									line-height: 20px;
									padding-top: 8px;
									border-bottom: 1px solid var(--color-grey-light);
									display: block;
									width: 100%;
									font-weight: var(--font-weight-bold);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									color: var(--color-dark);
									font-family: var(--font-family-poppins);
									text-transform: uppercase;
									padding-top: 8px;
									padding-bottom: 10px;

									&:focus{
										border-color: var(--color-blue);
									}

									&::placeholder{
										font-weight: var(--font-weight-regular);
									}
								}
							}
						}
					}
					
					.preseleccion-personas{
						width: 100%;

						display: grid;
						grid-template-columns: repeat(2, 1fr);
						grid-auto-rows: 1fr;
						grid-column-gap: 15px;
						grid-row-gap: 15px;

						.preseleccion-personas-title{
							margin: 0;
							font-size: 14px;
							line-height: 18px;
							font-family: var(--font-family-fira);
							font-weight: var(--font-weight-bold);
							color: var(--color-dark);
							margin-bottom: 5px;
						}

						.preseleccion-persona{
							width: 100%;
							border: none;
							border-radius: 0px;
							margin: 0px;
							padding: 0px;
							@include flex(row, flex-start, center);
							align-items: stretch;
							transition: all .2s;
							background-color: var(--color-blue);
							position: relative;
							// overflow: hidden;
							

							.preseleccion-persona-content{
								width: calc(100% - 32px);
								@include flex(row, space-between, center);
								align-items: stretch;
								cursor: pointer;

								&:hover{
									opacity: .9;
								}
							}

							.preseleccion-persona-eliminar{
								// position: absolute;
								background-color: var(--color-red);
								// bottom: -8px;
								// left: -12px;
								// z-index: 10;
								width: 32px;
								height: 100%;
								// border-radius: 99%;
								display: flex;
								flex-direction: row;
								justify-content: center;
								align-items: center;
								cursor: pointer;

								svg{
									color: white;
									width: 16px;
									height: auto;
								}

								&:hover{
									opacity: .9;
								}
							}

							.preseleccion-persona-eliminar-confirm{
								min-height: 60px;
								width: calc(100% - 32px);
								@include flex(row, space-between, center);
								align-items: stretch;
								background-color: var(--color-red);

								span{
									width: calc(100% - 54px);
									padding: 10px;
									font-size: 11px;
									color: var(--color-white);
									display: flex;
									justify-content: center;
									align-items: center;
								}

								button{
									width: 54px;
									appearance: none;
									outline: none;
									border: none;
									background-color: var(--color-blue);
									color: var(--color-white);
									padding: 4px 8px;
									font-weight: 700;
									font-size: 12px;
									font-family: var(--font-family-poppins);
									line-height: 1em;
									cursor: pointer;
								}
							}

							.preseleccion-persona-left{
								@include flex(column, center, flex-start);
								padding: 10px;

								.preseleccion-nombre{
									font-size: 12px;
									line-height: 20px;
									font-family: var(--font-family-poppins);
									font-weight: 700;
									letter-spacing: 0.3px;
									color: var(--color-white);
									text-transform: uppercase;
								}

								.preseleccion-documento{
									font-size: 12px;
									line-height: 20px;
									font-family: var(--font-family-poppins);
									font-weight: 400;
									color: var(--color-white);
									text-transform: uppercase;
								}
							}

							.preseleccion-persona-right{
								// -webkit-transform: skew(-15deg, 0deg);
								// -moz-transform: skew(-15deg, 0deg);
								// -o-transform: skew(-15deg, 0deg);
								// transform: skew(-15deg, 0deg);
								padding: 0px 18px 0px 18px;
								// margin-right: -10px;
								background-color: var(--color-blue-dark);
								@include flex(column, center, center);

								svg{
									color: var(--color-white);
									width: 18px;
									// -webkit-transform: skew(15deg, 0deg);
									// -moz-transform: skew(15deg, 0deg);
									// -o-transform: skew(15deg, 0deg);
									// transform: skew(15deg, 0deg);
								}
							}
						}
					}
				}
			}

			.preseleccion-palco-loader{
				@include flex(row, center, center);
				width: 100%;
				height: calc(100% - 56px);
				position: absolute;
				bottom: 0px;
				left: 0px;
				z-index: 999;
				
				.loader{
					@include flex(column, center, center);

					span{
						font-family: var(--font-family-poppins);
						text-transform: uppercase;
						font-weight: var(--font-weight-bold);
						margin-top: 12px;
						color: #16497e;
						font-size: 14px;
					}

					img{
						width: 60px;
					}
				}
			}

			@media screen and (min-width: 992px){
				max-width: 400px;
			}
		}
	}





















	.promptComunicaciones {
		.vm--overlay{
			background: rgba(0, 0, 0, 0.9);
		}

		.vm--modal{
			@include flex(column, center, center);
			width: calc(100vw - 48px) !important;
			max-height: calc(100vh - 48px) !important;
			height: 700px !important;
			max-width: 600px !important;
			top: 50% !important;
			left: 50% !important;
			transform: translate(-50%, -50%) !important;
			padding: 0px;
			background-color: var(--color-white);
			border-radius: 0px;

			// Estilos popup
			.comunicaciones-content{
				width: 100%;
				height: 100%;
				position: relative;
				@include flex(column, flex-start, flex-start);

				.comunicaciones-header{
					width: 100%;
					padding: 0px;
					border-radius: 0px;
					height: 66px;
					@include flex(row, space-between, flex-start);

					.comunicaciones-cerrar{
						cursor: pointer;
						margin: 0;
						padding: 0px;
						border-radius: 0px;
						background-color: var(--color-red);
						width: 56px;
						height: 56px;
						@include flex(row, center, center);

						svg{
							color: var(--color-white);
							width: 24px;
							height: auto;
						}
					}

					.atencion{
						padding-top: 6px;
						padding-left: 20px;
						@include flex(row, flex-start, center);
						color: var(--color-red);
						font-weight: initial;
						font-size: 48px;
						line-height: 46px;
						font-family: var(--font-family-kapra-bold);
						text-transform: uppercase;
					}
				}

				.comunicaciones-main{
					width: 100%;
					height: calc(100% - 56px);
					padding: 20px;
					overflow-y: scroll;

					&::-webkit-scrollbar-track
					{
						-webkit-box-shadow: inset 0 0 6px var(--color-white);
						box-shadow: inset 0 0 6px var(--color-white);
						background-color: var(--color-white);
					}

					&::-webkit-scrollbar
					{
						width: 6px;
						background-color: var(--color-white);
					}

					&::-webkit-scrollbar-thumb
					{
						background-color: var(--color-grey-medium);
					}

					.comunicacion{
						width: 100%;
						padding-bottom: 20px;
						margin-bottom: 20px;
						border-bottom: 1px solid rgba(0, 0, 0, 0.1);
						@include flex(column, flex-start, flex-start);

						div{
							font-family: var(--font-family-fira);
							color: var(--color-blue-dark);
							font-size: 16px;
							margin-top: 3px;
							font-weight: (--font-weight-bold);
						}

						&:last-child{
							border-bottom: none;
							padding-bottom: 0px;
						}

						.comunicacion-archivo{
							width: 100%;
							@include flex(row, flex-start, flex-start);
							margin: 10px 0px;
						}
					}
				}
			}

			@media screen and (min-width: 992px){
				max-width: 400px;
			}
		}
	}


















	.promptSolicitudExitosa {
		.vm--overlay{
			background: rgba(0, 0, 0, 0.9);
		}

		.vm--modal{
			@include flex(column, center, center);
			width: calc(100vw - 48px) !important;
			max-height: calc(100vh - 48px) !important;
			height: 400px !important;
			max-width: 450px !important;
			top: 50% !important;
			left: 50% !important;
			transform: translate(-50%, -50%) !important;
			padding: 0px;
			background-color: var(--color-white);
			border-radius: 0px;

			// Estilos popup
			.solicitud-exitosa-content{
				width: 100%;
				height: 100%;
				position: relative;
				padding: 20px;
				@include flex(column, center, flex-start);

				.solicitud-exitosa-header{
					width: 100%;
					margin: 0px 0px 20px 0px;
					@include flex(row, center, center);

					.checkmark__circle {
						stroke-dasharray: 166;
						stroke-dashoffset: 166;
						stroke-width: 2;
						stroke-miterlimit: 10;
						stroke: #7ac142;
						fill: none;
						animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
					}

					.checkmark {
						width: 56px;
						height: 56px;
						border-radius: 50%;
						display: block;
						stroke-width: 2;
						stroke: #fff;
						stroke-miterlimit: 10;
						margin: 0 auto;
						margin-bottom: 20px;
						box-shadow: inset 0px 0px 0px #7ac142;
						animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
					}

					.checkmark__check {
						transform-origin: 50% 50%;
						stroke-dasharray: 48;
						stroke-dashoffset: 48;
						animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
					}

					@keyframes stroke {
						100% {
							stroke-dashoffset: 0;
						}
					}
					@keyframes scale {
						0%, 100% {
							transform: none;
						}
						50% {
							transform: scale3d(1.1, 1.1, 1);
						}
					}
					@keyframes fill {
						100% {
							box-shadow: inset 0px 0px 0px 30px #7ac142;
						}
					}
				}

				.solicitud-exitosa-main{
					width: 100%;
					@include flex(row, center, center);

					.title{
						margin: 0;
						margin-top: -5px;
						color: var(--color-red);
						font-weight: initial;
						font-size: 38px;
						line-height: 36px;
						font-family: var(--font-family-kapra-bold);
						text-transform: uppercase;
						text-align: center;
					}
				}

				.solicitud-exitosa-footer{
					width: 100%;
					margin: 20px 0px;
					@include flex(row, center, center);

					span{
						text-align: center;
						font-family: var(--font-family-fira);
						font-size: 15px;
						line-height: 21px;
						color: var(--color-dark);
					}
				}

				.solicitud-exitosa-boton{
					width: 100%;
					@include flex(row, center, center);

					.btn{
						@include flex(row, center, center);
						text-transform: uppercase;
						font-family: var(--font-family-poppins);
						font-weight: var(--font-weight-bold);
						position: relative;
						cursor: pointer;
						background-color: var(--color-blue);
						color: var(--color-white);
						-webkit-transition: background-color .2s ease;
						transition: background-color .2s ease;
						-webkit-letter-spacing: 1px;
						-moz-letter-spacing: 1px;
						-ms-letter-spacing: 1px;
						letter-spacing: 1px;
						min-height: 42px;
						padding: 0 24px;
						font-size: 14px;
						line-height: 1em;
						-webkit-font-smoothing: antialiased;
						-moz-osx-font-smoothing: grayscale;
						outline-color: transparent;
						outline: none;
						box-shadow: none;
						border: 0;
						margin: 0;
						text-decoration: none;

						&:hover{
							opacity: 0.9;
						}
					}
				}
			}

			@media screen and (min-width: 992px){
				max-width: 400px;
			}
		}
	}

	.promptRegistroPrensaExitoso {
		.vm--overlay{
			background: rgba(0, 0, 0, 0.9);
		}

		.vm--modal{
			@include flex(column, center, center);
			width: calc(100vw - 48px) !important;
			max-height: calc(100vh - 48px) !important;
			height: 400px !important;
			max-width: 450px !important;
			top: 50% !important;
			left: 50% !important;
			transform: translate(-50%, -50%) !important;
			padding: 0px;
			background-color: var(--color-white);
			border-radius: 0px;

			// Estilos popup
			.registro-exitoso-content{
				width: 100%;
				height: 100%;
				position: relative;
				padding: 20px;
				@include flex(column, center, flex-start);

				.registro-exitoso-header{
					width: 100%;
					margin: 0px 0px 20px 0px;
					@include flex(row, center, center);

					.checkmark__circle {
						stroke-dasharray: 166;
						stroke-dashoffset: 166;
						stroke-width: 2;
						stroke-miterlimit: 10;
						stroke: #7ac142;
						fill: none;
						animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
					}

					.checkmark {
						width: 56px;
						height: 56px;
						border-radius: 50%;
						display: block;
						stroke-width: 2;
						stroke: #fff;
						stroke-miterlimit: 10;
						margin: 0 auto;
						margin-bottom: 20px;
						box-shadow: inset 0px 0px 0px #7ac142;
						animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
					}

					.checkmark__check {
						transform-origin: 50% 50%;
						stroke-dasharray: 48;
						stroke-dashoffset: 48;
						animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
					}

					@keyframes stroke {
						100% {
							stroke-dashoffset: 0;
						}
					}
					@keyframes scale {
						0%, 100% {
							transform: none;
						}
						50% {
							transform: scale3d(1.1, 1.1, 1);
						}
					}
					@keyframes fill {
						100% {
							box-shadow: inset 0px 0px 0px 30px #7ac142;
						}
					}
				}

				.registro-exitoso-main{
					width: 100%;
					@include flex(row, center, center);

					.title{
						margin: 0;
						margin-top: -5px;
						color: var(--color-red);
						font-weight: initial;
						font-size: 38px;
						line-height: 36px;
						font-family: var(--font-family-kapra-bold);
						text-transform: uppercase;
						text-align: center;
					}
				}

				.registro-exitoso-footer{
					width: 100%;
					margin: 20px 0px;
					@include flex(row, center, center);

					span{
						text-align: center;
						font-family: var(--font-family-fira);
						font-size: 15px;
						line-height: 21px;
						color: var(--color-dark);
					}
				}

				.registro-exitoso-boton{
					width: 100%;
					@include flex(row, center, center);

					.btn{
						@include flex(row, center, center);
						text-transform: uppercase;
						font-family: var(--font-family-poppins);
						font-weight: var(--font-weight-bold);
						position: relative;
						cursor: pointer;
						background-color: var(--color-blue);
						color: var(--color-white);
						-webkit-transition: background-color .2s ease;
						transition: background-color .2s ease;
						-webkit-letter-spacing: 1px;
						-moz-letter-spacing: 1px;
						-ms-letter-spacing: 1px;
						letter-spacing: 1px;
						min-height: 42px;
						padding: 0 24px;
						font-size: 14px;
						line-height: 1em;
						-webkit-font-smoothing: antialiased;
						-moz-osx-font-smoothing: grayscale;
						outline-color: transparent;
						outline: none;
						box-shadow: none;
						border: 0;
						margin: 0;
						text-decoration: none;

						&:hover{
							opacity: 0.9;
						}
					}
				}
			}

			@media screen and (min-width: 992px){
				max-width: 400px;
			}
		}
	}

	.Vue-Toastification__toast{
		box-shadow: none !important;
	}

	.Vue-Toastification__toast--error{
		background-color: var(--color-red) !important;
	}

	.Vue-Toastification__toast-body{
		color: var(--color-white) !important;
		font-family: var(--font-family-poppins) !important;
		font-size: 13px !important;
		text-transform: uppercase;
		font-weight: bold;
	}

	.Vue-Toastification__close-button{
		color: var(--color-white) !important;
	}
	.Vue-Toastification__progress-bar{
		background-color: var(--color-white) !important;
	}

	// /* Galeria sectores */
	// .my-gallery{
	// 	@include flex-important(row, flex-start, center);

	// 	.gallery-thumbnail{
	// 		margin: 0px !important;
	// 		margin-left: 6px !important;
	// 		@include flex-important(row, center, center);

	// 		&:first-child{
	// 			margin-left: 0px !important;
	// 		}

	// 		a{
	// 			@include flex-important(row, center, center);

	// 			img{
	// 				height: auto !important;
	// 				width: 45px !important;
	// 				margin: 0px !important;
	// 				border-radius: 3px !important;
	// 			}
	// 		}
	// 	}
	// }

	/* Galeria sectores */
	.my-gallery{
		margin-top: 10px;
		@include flex-important(row, flex-start, center);

		.gallery-thumbnail{
			margin: 0px !important;
			margin-left: 10px !important;
			@include flex-important(row, center, center);

			&:first-child{
				margin-left: 0px !important;
			}

			a{
				@include flex-important(row, center, center);
				overflow: hidden;
				border-radius: 6px !important;
				position: relative;

				img{
					height: auto !important;
					width: 134px !important;
					margin: 0px !important;
					aspect-ratio: 3/2 !important;
					object-fit: cover !important;
					transition: 0.4s cubic-bezier(0.17, 0.67, 0.13, 1.02) 0s;

					&:hover{
						transform: scale(1.1) rotate(0.01deg);
					}
				}

				&:after{
					content: '';
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background: rgb(255,255,255);
					background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(0,0,0,0.3) 100%);
				}
			}
		}
	}

	@media screen and (max-width: 1000px){
		.cookie-info{
			@include flex(column, flex-end, center);

			.cookie-info-left{
				max-width: 100%;
				width: 100%;
				padding: 16px;
				font-size: 13px;
				line-height: 1em;
			}

			.cookie-info-close{
				width: 100%;
				min-height: 40px;
				line-height: 21px;
				padding: 0 24px;
				font-size: 14px;
			}
		}
	}

	@media screen and (max-width: 690px){
		.promptEliminarAmigo, .promptCancelarReserva, .promptCancelarTicket {
			.vm--modal{
				padding: 20px 20px 32px;

				h2{
					margin-bottom: 20px;
					font-size: 33px;
					line-height: 30px;
				}

				p{
					font-size: 14px;
					line-height: 16px;
				}

				div{
					margin-top: 20px;

					button{
						width: calc(50% - 6px);
						min-height: 42px;
						padding: 0 16px;
						font-size: 14px;
						line-height: 22px;
					}
				}
			}
		}
	}

	@media screen and (max-width: 590px){
		.promptPreseleccionPalco, .promptPreseleccionIntegrante {
			.vm--modal{
				.preseleccion-palco-content{
					.preseleccion-palco-main{
						.preseleccion-filtros{
							.preseleccion-filtro-row{
								@include flex(column, flex-start, flex-start);
								.preseleccion-filtro{
									width: 100%;
									margin-bottom: 10px;
								}
							}
						}
						
						.preseleccion-personas{
							grid-template-columns: repeat(1, 1fr);
							grid-auto-rows: initial;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 480px){
		.promptCancelarTicket {
			.vm--modal{
				padding: 20px;

				div{
					@include flex(column, flex-start, flex-start);
					margin-top: 20px;

					button{
						width: 100%;
						min-height: 42px;
						padding: 0 16px;
						font-size: 14px;
						line-height: 22px;
						margin-top: 10px;
					}
				}
			}
		}
	}
</style>